var eventTypes = {
    CLICK: "click",
    MOUSE_DOWN: "mousedown",
    MOUSE_UP: "mouseup",
    MOUSE_ENTER: "mouseenter",
    MOUSE_LEAVE: "mouseleave",
    MOUSE_MOVE: "mousemove",
    MOUSE_WHEEL: "mousewheel",
    TOUCH_START: "touchstart",
    TOUCH_END: "touchend",
    TOUCH_MOVE: "touchmove",
    WHEEL: "wheel",
    SCROLL: "scroll",
    RESIZE: "resize",
    LOAD: "load",
    READY_STATE_CHANGE: "readystatechange",
    POP_STATE: "popstate",
};
export default eventTypes;
